import { useAgeVerification } from '@/context/AgeVerificationContext';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

export default function AgeGate() {
  const { isVerified, verify } = useAgeVerification();

  if (isVerified) return null;

  const handleExit = () => {
    window.location.href = 'https://www.google.com';
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center">
      {/* Blurred background */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1518893063132-36e46dbe2428?w=1920)',
          filter: 'blur(20px)',
        }}
      />
      <div className="absolute inset-0 bg-black/80" />
      
      {/* Modal */}
      <div className="relative z-10 w-full max-w-md mx-4 animate-slide-up">
        <div className="glass rounded-2xl p-8 text-center">
          {/* Logo */}
          <div className="mb-2">
            <img 
              src="/logo-white.png" 
              alt="Intimate.pt" 
              className="h-14 w-auto mx-auto"
            />
          </div>
          <p className="text-muted-foreground text-sm mb-8">
            Contos Eróticos para Adultos
          </p>
          
          {/* Warning */}
          <div className="bg-ruby/10 border border-ruby/30 rounded-lg p-4 mb-8">
            <p className="text-ruby-light font-medium mb-2">
              Conteúdo Adulto (+18)
            </p>
            <p className="text-muted-foreground text-sm">
              Este site contém material erótico destinado exclusivamente a adultos.
              Ao entrares, confirmas ter 18 anos ou mais.
            </p>
          </div>
          
          {/* Buttons */}
          <div className="space-y-3">
            <Button 
              onClick={verify}
              data-testid="age-verify-btn"
              className="w-full bg-ruby hover:bg-ruby-light text-white rounded-full py-6 font-semibold text-lg transition-all duration-300 hover:shadow-[0_0_30px_rgba(155,17,30,0.5)]"
            >
              Tenho 18 anos ou mais
            </Button>
            <Button 
              onClick={handleExit}
              variant="ghost"
              data-testid="age-exit-btn"
              className="w-full text-muted-foreground hover:text-white rounded-full py-6"
            >
              <X className="w-4 h-4 mr-2" />
              Sair do site
            </Button>
          </div>
          
          {/* Disclaimer */}
          <p className="text-muted-foreground text-xs mt-8">
            Ao clicares em "Tenho 18 anos ou mais", concordas com os nossos 
            Termos de Utilização e confirmas que és maior de idade na tua jurisdição.
          </p>
        </div>
      </div>
    </div>
  );
}
